$(document).ready(function () {
$(".dropdown-toggle-two").click(function(){
  $(".dropdown-menu-two").toggleClass("langopen");
});

$(".dropdown-toggle-one").click(function(){
  $(".dropdown-menu-one").toggleClass("langopen");
});
  
});  

$(document).ready(function () {
$(".site-footer-block-title").click(function() {
    // Get the current data-accordion-trigger attribute
 $(this).toggleClass("accordion-trigger-true");
  var nextContent = $(this).next(".site-footer-block-content");
  nextContent.toggleClass("accordion-content-true");


  });
  });

$(document).ready(function () {
  if ($(window).width() < 1024) {
  $(".navmenu-depth-3 .navmenu-link").click(function(event) {                
                event.preventDefault();
                var href = $(this).attr("href");
               window.location.href = href;
     setTimeout(function() {
                    window.location.reload();
                }, 1000); 
            });
    }
}); 